import "@sortera/react-components/style.css";
import "./global.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./app.tsx";
import { createAuth } from "./integrations/auth.ts";
import { startColorScheme } from "./integrations/color-scheme.ts";
import { fetchConfig } from "./integrations/config.ts";
import { setTokenSource } from "./integrations/http.ts";

// Before anything renders, so the first paint is already in the right colours.
startColorScheme();

const root = createRoot(document.getElementById("root")!);

try {
  const config = await fetchConfig();
  const auth = await createAuth(config);
  setTokenSource(() => auth.token());
  root.render(
    <StrictMode>
      <App auth={auth} config={config} />
    </StrictMode>,
  );
} catch (error) {
  console.error(error);
  root.render(<p style={{ padding: "var(--wk-spacing-xl)" }}>Sortera Factory kunde inte starta. Ladda om sidan om en stund.</p>);
}
